import React from 'react'
import className from 'classnames/bind'

import style from './MyhousePrice.module.scss'

const cx = className.bind(style)

type Props = {
  buildingName?: any
  unitName?: any
  name?: any
  yearlyGrowthType?: any
  yearlyGrowthRatio?: any
  basisDate?: any
  moreInfoHandler?: any
  price?: any
  priceList?: any
  prevYear?: any
  tax?: any
}

const MyhousePrice: React.FC<Props> = ({ name, yearlyGrowthType, prevYear, price, priceList, yearlyGrowthRatio, tax }: Props) => {
  return (
    <div className={cx('article')}>
      <span className={cx('unit')}>{name}</span>
      <strong className={cx('price')}>{price}</strong>
      {priceList && (
        <ul className={cx('information')}>
          {priceList.map((item: any, index: number) => (
            <li className={cx('description')} key={index}>
              {item.title}
              {/* todo: count에 증가일때 plus, 감소일때 minus 추가 */}
              <span className={cx('count', item.type)}>
                {item.type === 'plus' && '+'}
                {item.text}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default MyhousePrice
